import Tabs from "common/Tabs/Tabs";
import React from "react";
import Title from "common/Typography/Title";
import Flex from "common/Boxes/Flex";
import { ArrowRightOutlined } from "common/Icons/Icons";
import styled from "styled-components";
import { typography } from "@shared/common/Themes/typography";
import ClientForm from "features/configuration/accounts/CreateAccount/ClientForm";
import { AddClientResponse, ClientData } from "@shared/types";
import Form from "antd/es/form";
import { CREATE_ACCOUNT_PATH } from "common/constants";
import { useHistory } from "react-router-dom";
import { ConnectExchangeTabs } from "@shared/features/portfolio/types";
import useConnectExchange from "@shared/features/portfolio/createAccount/useConnectExchange";
import ChangeAccountTypeMessage from "features/configuration/accounts/CreateAccount/ChangeAccountTypeMessage";
import { useBottomNavigator } from "utils/hooks/misc";

interface ConnectExchangeProps {
  primaryExchange?: string;
  account?: ClientData;
  getErrorNotification?: (description: string, title?: string) => void;
  isOnboarding?: boolean;
  onSubmitSuccess?: () => void;
  getSuccessMessage?: (
    response?: AddClientResponse,
    exchangesList?: string[]
  ) => void;
}

const ConnectExchange = ({
  primaryExchange,
  account,
  getErrorNotification,
  isOnboarding,
  onSubmitSuccess,
  getSuccessMessage,
}: ConnectExchangeProps) => {
  const history = useHistory();
  const [form] = Form.useForm();
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();

  const { showTabs, tab, setTab, closeDrawer, onBackToSelectExchange } =
    useConnectExchange({
      primaryExchange,
      account,
    });

  const props = {
    form,
    getErrorNotification,
    isOnboarding,
    onSubmitSuccess,
    primaryExchange,
    account,
    isQuickConnect: tab === ConnectExchangeTabs.QUICK_CONNECT,
    closeDrawer,
    getSuccessMessage,
  };
  const connectExchangeForm = <ClientForm {...props} />;
  const mobilePadding =
    isBottomNavigator && !isOnboarding ? { padding: "0 16px" } : undefined;

  let content = connectExchangeForm;
  if (isBottomNavigator) {
    content = (
      <>
        <FormWrapper style={mobilePadding} $isOnboarding={isOnboarding}>
          {connectExchangeForm}
        </FormWrapper>
        {!account && !isOnboarding && (
          <div style={mobilePadding}>
            <ChangeAccountTypeMessage style={{ marginTop: 16 }} />
          </div>
        )}
      </>
    );
  }

  const tabsItems = [
    {
      key: ConnectExchangeTabs.QUICK_CONNECT,
      label: ConnectExchangeTabs.QUICK_CONNECT,
    },
    {
      key: ConnectExchangeTabs.API_KEYS,
      label: ConnectExchangeTabs.API_KEYS,
    },
  ];

  const onBackClick = () => {
    history.push(CREATE_ACCOUNT_PATH);
    onBackToSelectExchange?.();
  };

  return (
    <>
      <div style={mobilePadding}>
        {!account && !isOnboarding && (
          <TitleWrapper>
            <Arrow onClick={onBackClick} />
            <Title level={3} $weight={typography.fontWeights.SEMI_BOLD}>
              Connect {primaryExchange}
            </Title>
          </TitleWrapper>
        )}
        {showTabs && (
          <Tabs activeKey={tab} onChange={setTab} items={tabsItems} />
        )}
      </div>
      {content}
    </>
  );
};

export default ConnectExchange;

const TitleWrapper = styled(Flex)`
  margin-bottom: 20px;
  justify-content: flex-start;
`;
const Arrow = styled(ArrowRightOutlined)`
  width: 24px;
  height: 24px;
  rotate: 180deg;
  margin-right: 12px;
  cursor: pointer;
  fill: ${(p) => p.theme.colors.primaryGrey};
`;
const FormWrapper = styled.div<{ $isOnboarding?: boolean }>`
  ${(p) =>
    !p.$isOnboarding &&
    `
    flex: 1;
    overflow: auto;
  `};
`;
